import styled from "styled-components";
import {AppHeaderCrossBrandListDefaultBox} from "./app-header-cross-brand-list.default.box";

export const AppHeaderCrossBrandListMrGreenBox = styled(AppHeaderCrossBrandListDefaultBox)`
  @media ${({theme}) => theme.mediaQuery.xlAndAbove} {
    background-color: ${props => props.theme.colors.brandSecondary};
    color: ${props => props.theme.colors.textLight};
  }
`